let szenedata = 5;
import { sitePos } from "./sitepos";

sitePos(szenedata);